module.exports = __webpack_public_path__ + "static/media/china.c4d0db3e.svg";